import { useFileDownloader, useJobCreation, useJobPolling } from '../../../../../api';
import { USER_MANAGEMENT_BASE_URL } from '../../../../UserManagement/api/consts';
import { useEffect } from 'react';

interface Params {
    onSuccess?: () => void;
    onError?: (error?: string) => void;
}

export const useDownloadAccountMatchingCsv = ({ onSuccess, onError }: Params) => {
    const {
        createJob,
        jobId,
        loading: creating
    } = useJobCreation({
        generateUrl: `${USER_MANAGEMENT_BASE_URL}/generateAccountMatchingFilesJob`
    });

    const {
        job,
        loading: polling,
        error: pollingError,
        errorMessage: pollingErrorMessage
    } = useJobPolling<{ responseIds: string[] }>(
        `${USER_MANAGEMENT_BASE_URL}/getAccountMatchingFilesJobStatus/${jobId}`,
        jobId
    );

    const {
        downloadFiles,
        downloading,
        error: downloadError
    } = useFileDownloader({ downloadUrl: `${USER_MANAGEMENT_BASE_URL}/downloadAccountMatchingFile`, onSuccess });

    useEffect(() => {
        if (job?.status === 'completed' && job.result?.responseIds) {
            downloadFiles(job.result.responseIds);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [job?.jobId, job?.status]);

    useEffect(() => {
        if (pollingError || downloadError) {
            onError?.(pollingErrorMessage || 'Failed to download file');
        }
    }, [pollingError, downloadError, onError, pollingErrorMessage]);

    return { loading: creating || polling || downloading, generateAndDownloadAccountMatchingFile: createJob };
};
